module.exports = __webpack_public_path__ + "static/media/friends-circle.bdb71953.jpg";